import { render, staticRenderFns } from "./QTabs.vue?vue&type=template&id=2d21b0ec&"
import script from "./QTabs.vue?vue&type=script&lang=js&"
export * from "./QTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports